import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pferdepass-antrag-preis"
export default class extends Controller {
  static targets = ["total", "zusatz", "zusammenfassungZusatz"]
  static values = {
    basis:  { type: Number, default: 0 },
    locale: { type: String, default: "de-CH" }
  }

  connect() {
    this.aktualisieren()
  }

  aktualisieren() {
    const summe = this.zusatzTargets.reduce(
      (total, ausloeser) => (ausloeser.checked ? total + this.betrag(ausloeser) : total),
      this.basisValue
    )

    this.zusammenfassungZusatzTargets.forEach((zeile) => {
      zeile.classList.toggle("d-none", !this.gewaehlt(zeile.dataset.schluessel))
    })
    this.totalTargets.forEach((ziel) => { ziel.textContent = this.formatCHF(summe) })
  }

  gewaehlt(schluessel) {
    return this.zusatzTargets.some((ausloeser) => ausloeser.checked && ausloeser.dataset.schluessel === schluessel)
  }

  betrag(ausloeser) {
    const preis = parseFloat(ausloeser.dataset.preis || "0")

    return isNaN(preis) ? 0 : preis
  }

  formatCHF(betrag) {
    return new Intl.NumberFormat(this.localeValue, {
      style: "currency",
      currency: "CHF",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(betrag)
  }
}
